<template>
  <div class="navbar">
    <ith-left-asside-bar v-show="menuLeftAsside == true" />
    <ith-asside-bar v-show="menuAsside == true" />

    <ith-login-user v-show="loginModal" />
    <ith-register-user v-show="registerModal" />
    <ith-forgot-password v-show="forgotModal" />
    <ith-language v-show="languageModal" />
    <ith-alert />
    <div class="container">
      <div class="topbar">
        <transition
          name="slide-fade"
          :duration="{ enter: 1500, leave: 100 }"
          mode="out-in"
        >
          <div
            class="brand"
            style="text-decoration: none"
            v-show="!searchfloat"
          >
            <div class="bars--icon menu-left-mobile" @click="verMenuLeftAsside">
              <font-awesome-icon id="bars--btn-icon" icon="bars" />
            </div>
            <div @click="resetSearch()" v-show="!searchfloat">
              <img
                :src="require('../../../assets/logo_ott.png')"
                alt="logo"
                height="60px"
              />
            </div>
          </div>
        </transition>
        <div class="menu">
          <a
            style="text-decoration: none"
            href="/"
            exact
            class="menu--item-link"
          >
            <span class="menu--item" :class="{ active: active }"> Home </span>
          </a>
          <template v-for="i in items">
            <router-link
              :key="i.id"
              style="text-decoration: none"
              :to="i.link"
              exact
              class="menu--item-link"
            >
              <span class="menu--item">
                {{ i.text }}
              </span>
            </router-link>
          </template>
        </div>
        <transition name="slide-fade" mode="out-in">
          <div v-show="searchfloat" class="float-search">
            <ith-seach-input class="search--bar" />
          </div>
        </transition>
        <div class="search--area">
          <ith-seach-input class="search-area" />
          <span class="search--hidden">
            <font-awesome-icon
              color="#ffffff"
              class="search--icon"
              icon="search"
              v-show="!searchfloat"
              @click="searchfloat = !searchfloat"
            />
            <font-awesome-icon
              color="#ffffff"
              class="search--icon"
              icon="times"
              v-show="searchfloat"
              @click="searchfloat = !searchfloat"
            />
          </span>
        </div>

        <div class="user--area">
          <div class="user--icon" @click="verMenuAsside">
            <font-awesome-icon
              color="#4CAF50"
              id="user--btn-icon"
              icon="user"
            />
          </div>
          <div
            class="user-flag menu-left-mobile-hidden"
            @click="verMenuLanguage"
          >
            <img
              v-if="user.country == 'USA'"
              src="/img/usa.png"
              alt="conutry"
              height="25px"
            />
            <img v-else src="/img/ind.png" alt="conutry" height="25px" />
          </div>
        </div>
      </div>
      <ith-ad-mobile-app />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    items: [
      { id: 1, text: "MustWatch", link: "/mustwatch" },
      { id: 2, text: "Upcoming", link: "/newupdates" },
      { id: 3, text: "Kids", link: "/kids" },
      { id: 4, text: "News | Reviews", link: "/articles" },
      { id: 5, text: "Watchlist", link: "/watchlist" }
    ],
    search: "",
    searchfloat: false,
    active: false
  }),
  computed: mapState([
    "menuLeftAsside",
    "menuAsside",
    "loginModal",
    "registerModal",
    "forgotModal",
    "languageModal",
    "alert",
    "user"
  ]),
  watch: {
    // search() {
    //   if (this.search.length > 2)
    //     this.$store.dispatch("FETCH_EDIT_CRITERIA", this.search);
    //   else this.$store.dispatch("FETCH_EDIT_CRITERIA", "");
    // }
  },
  mounted() {
    if (this.$route.name == "Home") this.active = true;
  },
  methods: {
    resetSearch() {
      // this.$store.dispatch("FETCH_EDIT_CRITERIA", "");
      // this.$router.push("/");
      window.location.href = "/";
    },
    verMenuAsside() {
      this.$store.commit("TOGGLE_MENU_ASSIDE");
    },
    verMenuLeftAsside() {
      this.$store.commit("TOGGLE_MENU_LEFT_ASSIDE");
    },
    verMenuLanguage() {
      this.$store.commit("TOGGLE_MENU_LANGUAGE");
    }
  }
};
</script>

<style scoped>
.navbar {
  background-color: #283441;
  height: 64px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  position: fixed;
  z-index: 1001;
}
.topbar {
  max-width: 1640px;
  color: white;
  margin-top: 0px;
  display: grid;
  grid-template-columns: 5% 40% 40% 15%;
  justify-content: center;
  align-items: center;
  column-gap: 1%;
  position: relative;
  height: 60px;
}

.brand {
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 1%;

  cursor: pointer;
  align-self: center;
}
.bars--icon {
  align-self: center;
}
.text--white {
  color: white;
}

.menu-left-mobile-hidden {
  display: initial;
}
.menu-left-mobile {
  display: none;
}

.menu {
  display: grid;
  grid-template-columns: repeat(6, auto);
  align-items: end;
}
.menu--item {
  color: white;
  padding-left: 3%;
}
.menu--item-link {
  font-weight: 400;
}
.active,
.router-link-active {
  font-weight: 800;
}
.search-area {
  display: grid;
  grid-template-columns: 100%;
  align-content: end;
  position: relative;
  justify-content: center;
}
.search--area {
  justify-self: center;
}
.search--bar {
  display: grid;
  grid-template-columns: 100%;
  align-content: end;
  position: relative;
}

.search--hidden {
  display: none;
  justify-self: center;
}
.user--area {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-self: center;
}
.user-flag {
  margin-left: 10px;
  margin-top: 5px;
  align-self: center;
}
.user--icon {
  border: 1px solid white;
  border-radius: 50%;
  font-size: 20px;
  margin: 5px 3px 0px 2px;
  width: 33px;
  height: 33px;
  cursor: pointer;
  text-align: center;
}
#user--btn-icon {
  padding-top: 5px;
  padding-left: 1px;
}
.search--icon {
  margin: 2px;
  width: 25px;
  height: 25px;
  cursor: pointer;
  text-align: center;
}
.float-search {
  align-self: center;
  width: 70%;

  /* position: absolute;
  width: 80%;
  margin-top: 55px;
  right: 0;
  top: 0;
  z-index: 1003; */
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s reverse;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

@media (min-width: 1264px) {
  .navbar {
    width: 100%;
  }
  .topbar {
    grid-template-columns: 17% 45% 33% 5%;
    position: relative;
  }
  .menu-left-mobile-hidden {
    display: initial;
  }
  .menu-left-mobile {
    display: none;
  }
  .search--area {
    width: 100%;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .navbar {
    width: 100%;
  }
  .topbar {
    grid-template-columns: 20% 40% 35% 5%;
    justify-content: space-around;
  }
  .user--icon {
    justify-self: end;
  }
  .menu {
    grid-template-columns: repeat(6, auto);
    font-size: 0.7em;
    column-gap: 0%;
  }
  .menu-left-mobile-hidden {
    display: initial;
  }
  .menu-left-mobile {
    display: none;
  }
  .search--area {
    width: 100%;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .navbar {
    width: 100%;
  }
  .topbar {
    grid-template-columns: 15% 35% 30% 12%;
    column-gap: 1%;
  }
  .menu {
    grid-template-columns: repeat(6, auto);
    font-size: 0.5em;
    column-gap: 0%;
  }
  .menu-left-mobile-hidden {
    display: initial;
  }
  .menu-left-mobile {
    display: none;
  }
  .search--area {
    width: 100%;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .navbar {
    width: 100%;
  }
  .topbar {
    grid-template-columns: 35% 45% 15%;
    column-gap: 1%;
  }
  .brand {
    justify-content: start;
  }
  .user--icon {
    justify-self: end;
  }
  .menu {
    display: none;
  }
  .menu-left-mobile-hidden {
    display: none;
  }
  .menu-left-mobile {
    display: initial;
  }
  .user--area {
    grid-template-columns: 100%;
    align-items: center;
  }
}

@media (max-width: 600px) {
  .topbar {
    display: flex;
    justify-content: space-around;
    /* grid-template-columns: 66% 15% 15%;*/
  }
  .brand {
    justify-content: start;
  }
  .user--icon {
    justify-self: end;
  }
  .menu,
  .search-area {
    display: none;
  }
  .menu-left-mobile-hidden {
    display: none;
  }
  .search--hidden,
  .menu-left-mobile {
    display: initial;
  }
  .user--area {
    grid-template-columns: 100%;
    align-items: center;
  }
}
</style>
<style>
input {
  color: white;
}

input::placeholder {
  color: white;
  font-family: Montserrat, Helvetica, Arial, sans-serif;
}
</style>
